import { useIntl } from "react-intl";
import React, { useState } from "react";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import Button from "@rio-cloud/rio-uikit/Button";
import ErrorDialog from "../../../../../../../components/dialogs/ErrorDialog";

interface ICreateServiceBayDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
}

const CreateServiceBayDialog = ({
  isOpen,
  onClose,
  onSave,
}: ICreateServiceBayDialogProps) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const [name, setName] = useState("");
  const [hasError, setHasError] = useState(false);

  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name || name.trim() === "") {
      setHasError(true);
      return;
    }

    try {
      setIsLoading(true);
      await onSave(name);
      setHasError(false);
      onClose();
      setError(null);
    } catch (error: any) {
      setError(error.message || intl.formatMessage({ id: "intl-msg:dealership.createServiceBay.createError" }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    setHasError(false);
  };

  return (
    <>
      <Dialog show={isOpen} onClose={onClose} showCloseButton bsSize="md">
        <form onSubmit={handleSubmit}>
          <Dialog.Title title={intl.formatMessage({ id: "intl-msg:dealership.createServiceBay.title" })} />

          <Dialog.Body>
            <div className="form-group">
              <label htmlFor="boxName" className="text-size-14">
                {intl.formatMessage({ id: "intl-msg:dealership.createServiceBay.name" })}
              </label>
              <input
                id="boxName"
                name="boxName"
                className={`form-control h-[44px] ${
                  hasError ? "border border-danger" : ""
                }`}
                placeholder={intl.formatMessage({ id: "intl-msg:dealership.createServiceBay.namePlaceholder" })}
                value={name}
                onChange={handleInputChange}
                required
                maxLength={20}
              />
              {hasError && (
                <p className="text-danger text-sm mt-1">
                  {intl.formatMessage({ id: "intl-msg:dealership.createServiceBay.nameRequired" })}
                </p>
              )}
            </div>
          </Dialog.Body>

          <Dialog.Footer>
            <Button
              className={`btn btn-primary ${
                isLoading ? "btn-loading disabled" : ""
              }`}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? intl.formatMessage({ id: "intl-msg:occurrence.saving" }) : intl.formatMessage({ id: "intl-msg:occurrence.save" })}
            </Button>
          </Dialog.Footer>
        </form>
      </Dialog>

      <ErrorDialog
        show={!!error}
        title={intl.formatMessage({ id: "intl-msg:dealership.createServiceBay.createError" })}
        body={error}
        onClose={() => setError(null)}
      />
    </>
  );
};

export default CreateServiceBayDialog;
